import Color from '../Color/Color'
import Header from '../Header/Header'
import Paragraph from '../Paragraph/Paragraph'
import UploadingFile from './UploadingFile'
import classes from './DragAndDropFile.module.scss'
import { FiUploadCloud } from 'react-icons/fi'
import { useState } from 'react'
import type { CSSProperties, ReactNode } from 'react'

const emptySpaceStyling: CSSProperties = {
  marginLeft: '0.25em'
}

export interface Props {
  allowedFileTypes: string[]
  onChange: (file: FileList) => void
  children?: ReactNode
  isUploading?: boolean
  ariaLabel?: string
}

const DragAndDropFile = ({
  allowedFileTypes = ['xlsx', 'csv', 'ods'],
  ariaLabel,
  onChange,
  children,
  isUploading = false
}: Props) => {
  const [isDragOver, setIsDragOver] = useState(false)
  const excludeLastAllowedFileType = allowedFileTypes.slice(0, -1)

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault()
    setIsDragOver(true)
  }

  const handleDragEnter = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault()
    setIsDragOver(true)
  }

  const handleDragLeave = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault()
    setIsDragOver(false)
  }

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault()
    setIsDragOver(false)

    const droppedFiles = event.dataTransfer.files

    onChange(droppedFiles)
  }

  const boxStyle = isDragOver
    ? classes.DragAndDropFile + ' ' + classes.dragOver
    : classes.DragAndDropFile

  return (
    isUploading
      ? <UploadingFile />
      : (
        <div
          aria-label={ariaLabel}
          className={boxStyle}
          onDragEnter={handleDragEnter}
          onDragLeave={handleDragLeave}
          onDragOver={handleDragOver}
          onDrop={handleDrop}
        >
          <Color variant='theme-drag-and-drop-box-icon-color'>
            <FiUploadCloud
              aria-hidden
              size={80}
            />
          </Color>
          <Header
            hasNoTopMargin
            rank={4}
          >
            <Color variant='theme-color-statuschip-text'>
              Drag and drop file here to upload
            </Color>
          </Header>
          <Paragraph>
            <strong>
              <Color variant='theme-color-id'>
                Supported file types:
              </Color>
              <Color variant='theme-color-statuschip-text'>
                <span style={emptySpaceStyling}>
                  {excludeLastAllowedFileType.join(', ')}
                  {' '}
                  <Color variant='theme-color-id'>
                    and
                  </Color>
                  {' '}
                  {allowedFileTypes[allowedFileTypes.length - 1]}
                </span>
              </Color>
            </strong>
          </Paragraph>
          {children}
        </div>
      )
  )
}

export default DragAndDropFile
